// extracted by mini-css-extract-plugin
export default {"root":"_3VFXr6AA80xWKtuzUw71rD","container":"_32fFaSeTWhF6qMvvO98O_u"};